import { InferValuesTypes, Team } from '@yandex-int/k-common/typings';
import { SimpleCallback } from 'platform-components';
import { THREE_DOTS_ITEM_TYPE } from 'platform-components/src/components/three-dots/typings';

import * as actions from './actions';

export enum TABS {
    STUDENTS = 'students',
    TEACHERS = 'teachers',
    SUBJECTS = 'subjects',
}

export interface MenuOption {
    onClick: SimpleCallback;
    textId: string;
    type: THREE_DOTS_ITEM_TYPE;
    withBorder: boolean;
}

export interface ClassState {
    classIdToDelete: number | null;
    submittingChanges: boolean;
    controlsStatus: boolean;
    isArchivateClassModalOpened: boolean;
    isClassNameEditorModalOpened: boolean;
    isAddingNewStudent: boolean;
    isStudentsListModalOpened: boolean;
    shouldRedirect: boolean;
    classItemToArchive: Team | null;
    createdTeamId: number | null;
}

export type ClassActions = ReturnType<InferValuesTypes<typeof actions>>;
